import { render, staticRenderFns } from "./picker-documents-list.vue?vue&type=template&id=1729cfe6&"
import script from "./picker-documents-list.vue?vue&type=script&lang=js&"
export * from "./picker-documents-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports